import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useHistory } from "react-router-dom";

import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import { createButtonPointAccess } from "../../repositories/buttonPointAccessRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import SelectCustom from "../../components/basic/SelectCustom";

const optionsJustify = {
  Esquerda: "flex-start",
  Direita: "flex-end",
  Centro: "center",
};

const CreateButtonPointAccess = () => {
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [color, setColor] = useState("");
  const [colorText, setColorText] = useState("");
  const [functionName, setFunctionName] = useState("");
  const [position, setPosition] = useState(null);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const resultValidation = validatesNotNull([
        { value: name, key: "name" },
        { value: width, key: "width" },
        { value: height, key: "height" },
        { value: color, key: "color" },
        { value: colorText, key: "colorText" },
        { value: functionName, key: "functionName" },
        { value: position, key: "position" },
      ]);
      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      }

      const result = await createButtonPointAccess({
        body: {
          Nome: name,
          Largura: width,
          Altura: height,
          Cor: color,
          CorTexto: colorText,
          Funcao: functionName,
          Posicao: position.Valor,
        },
      });
      setLoading(false);
      if (result) {
        notify("Registro criado com sucesso.", true, "info");
        goBack();
      }
    } catch (error) {
      console.error("ERROR: CreateButtonPointAccess", error);
      return setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={6}
          md={7}
          sm={7}
          xs={10}
          id="formContent"
        >
          <ArrowBackIcon className="iconGoBack" onClick={goBack} />

          <label className="title">Novo botão de ponto de acesso</label>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Nome*"
              autoFocus
              type="text"
              value={name}
              setValue={setName}
              error={errors.name}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={6}>
            <TextFieldCustom
              maxLength={10}
              label="Largura*"
              autoFocus
              type="text"
              value={width}
              setValue={setWidth}
              error={errors.width}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={6}>
            <TextFieldCustom
              maxLength={10}
              label="Altura*"
              autoFocus
              type="text"
              value={height}
              setValue={setHeight}
              error={errors.height}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={6}>
            <TextFieldCustom
              maxLength={50}
              label="Cor*"
              autoFocus
              type="text"
              value={color}
              setValue={setColor}
              error={errors.color}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={6}>
            <TextFieldCustom
              maxLength={50}
              label="Cor do texto*"
              autoFocus
              type="text"
              value={colorText}
              setValue={setColorText}
              error={errors.colorText}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <SelectCustom
              maxLength={50}
              label="Posição*"
              keyObject="Descricao"
              value={position}
              setValue={setPosition}
              error={errors.position}
              optionsList={[
                { Descricao: "Esquerda", Valor: "left" },
                { Descricao: "Direita", Valor: "right" },
                { Descricao: "Centro", Valor: "center" },
              ]}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Nome da função*"
              autoFocus
              type="text"
              value={functionName}
              setValue={setFunctionName}
              error={errors.functionName}
            />
          </Grid>

          {name && (
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              container
              justify="center"
            >
              <label className="title">Preview</label>
              <Grid item lg={12} md={12} sm={12} xs={12}></Grid>

              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                container
                justify={
                  position ? optionsJustify[position.Descricao] : "center"
                }
              >
                <Button
                  style={{
                    background: color,
                    color: colorText,
                    width,
                    height,
                    textTransform: "none",
                  }}
                >
                  {name}
                </Button>
              </Grid>
            </Grid>
          )}

          <button
            id="buttonStyle"
            type="submit"
            className="btn btn-info btn-block"
          >
            Inserir
          </button>
        </Grid>
      </Grid>
    </form>
  );
};
export default CreateButtonPointAccess;
